var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

var Select = function Select(_ref) {
  var _classnames;

  var children = _ref.children,
      className = _ref.className,
      readOnly = _ref.readOnly,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      warning = _ref.warning,
      error = _ref.error,
      flat = _ref.flat,
      boxed = _ref.boxed,
      disabled = _ref.disabled,
      props = _objectWithoutProperties(_ref, ["children", "className", "readOnly", "value", "defaultValue", "warning", "error", "flat", "boxed", "disabled"]);

  delete props.meta;
  delete props.loading;

  //Containing a possible error
  if (boxed) {
    console.warn("Boxed attribute is deprecated on Select elements."); //eslint-disable-line no-console
  }

  if (flat) {
    console.warn("Flat attribute is deprecated on Select elements."); //eslint-disable-line no-console
  }

  var actualValue = void 0;
  if (value) {
    actualValue = value;
  } else if (defaultValue) {
    actualValue = defaultValue;
  }

  var prefixCls = "cxa-c-form__select-box";

  var classNames = classnames(prefixCls, (_classnames = {}, _classnames[prefixCls + "--readonly"] = readOnly, _classnames[prefixCls + "--error"] = error, _classnames[prefixCls + "--warning"] = warning && !error, _classnames[prefixCls + "--disabled"] = disabled, _classnames), className);

  if (readOnly) {
    return actualValue;
  }

  return React.createElement(
    "span",
    { className: classNames },
    React.createElement(
      "select",
      _extends({ value: value, disabled: disabled }, props),
      children
    )
  );
};

Select.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  className: PropTypes.string,
  readOnly: PropTypes.bool,
  value: PropTypes.any,
  defaultValue: PropTypes.string,
  underline: PropTypes.bool,
  boxed: PropTypes.bool,
  flat: PropTypes.bool,
  error: PropTypes.any,
  meta: PropTypes.object
} : {};

export default Select;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/es/components/select/select.js
// module id = null
// module chunks = 